import { LoginScreen } from "@/features/auth/screens/LoginScreen";
import { resolveContactMethodFromAuthSearch } from "@/features/auth/utils/authMethodSearchParam";
import { createFileRoute } from "@tanstack/react-router";

const Login = () => {
    const { email, phone, contactMethod, method } = Route.useSearch();
    const contactMethodResolved = resolveContactMethodFromAuthSearch({ method, contactMethod });

    return <LoginScreen contactMethod={contactMethodResolved} email={email} phone={phone} />;
};

export const Route = createFileRoute("/_auth/_public/login/")({
    component: Login,
});
